import { LocalStorageKey } from '@/enums/local-storage-key'
import type { User } from '@shared/interfaces/user'
import { ref } from 'vue'

class UserService {
  private readonly demoUser: User = {
    id: '2837983479',
    token: '290304809sdfjlköhhjöklsdjjf#234'
  }

  public user = ref<User | undefined>(undefined)

  constructor() {
    this.initUser()
  }

  private initUser() {
    this.user.value = this.readFromLocalStorage()
  }

  public setUser(user: User) {
    this.user.value = user
    this.saveToLocalStorage(user)
  }

  public clearUser() {
    this.user.value = undefined
    localStorage.removeItem(LocalStorageKey.USER)
  }

  private saveToLocalStorage(user: User) {
    const userJSON = JSON.stringify(user)
    localStorage.setItem(LocalStorageKey.USER, userJSON)
  }

  private readFromLocalStorage(): User | undefined {
    const userJSON = localStorage.getItem(LocalStorageKey.USER)

    if (userJSON) {
      const user: User = JSON.parse(userJSON)
      return user
    }

    return undefined
  }
}
export default new UserService()
